import React, { Fragment, Component } from 'react';

import { connect } from 'react-redux';
import { Label, Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import moment from 'moment';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik, FieldArray } from 'formik';
import Loader from '~/components/loader/loader';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import BriteTankDropdown from '~/containers/briteTankDropdown/briteTankDropdown';

export const completeLotTransfersMutation = gql`
  mutation completeLotTransfers($breweryId: Int!, $lotTransfers: [TransferForLotTransferComplete]!) {
    completeLotTransfers(breweryId: $breweryId, lotTransfers: $lotTransfers) {
      id
    }
  }
`;

export const getBriteTanks = gql`
  query tanks($breweryId: Int!) {
    tanks(breweryId: $breweryId, type: BRITE_TANK) {
      id
      name
      volume
    }
  }
`;

export class TransferForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  setSubmitting = submitting => {
    this.setState({
      submitting
    });
  };

  setError = error => {
    this.setState({
      error
    });
  };

  render() {
    const { values, onCancelClick, brewery, onSuccess, refetchQueries, lotTransfers } = this.props;
    const { submitting, error } = this.state;

    return (
      <Mutation mutation={completeLotTransfersMutation}>
        {completeLotTransfers => (
          <Fragment>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              <p className="mb3">Which brite tanks do you want to transfer to?</p>
              <FieldArray
                name="transfers"
                validateOnChange={false}
                render={arrayHelpers => {
                  return (
                    <div>
                      {lotTransfers.map((l, idx) => {
                        const lot = l.consolidatedLot || l.lot;
                        return (
                          <div key={l.id} className="mb3 pb3 bb-divider">
                            <h4 className="mv0 f5">{lot.reference}</h4>
                            <p className="flex-grow-1">
                              Transfer {lot.currentVolume || lot.volume}L of {lot.product.name} on{' '}
                              {moment(l.startDate).format('dddd, MMMM Do')}
                            </p>
                            <div className="flex items-center mt2">
                              <Label className="nowrap mr3">Brite tank</Label>
                              <BriteTankDropdown
                                className="flex-grow-1"
                                value={l.tankId}
                                name={`transfers.${idx}.tankId`}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={onCancelClick}>
                Cancel
              </Button>{' '}
              <SubmissionButton
                color="primary"
                isSubmitting={submitting}
                onClick={async () => {
                  this.setSubmitting(true);

                  try {
                    await completeLotTransfers({
                      variables: {
                        breweryId: brewery.id,
                        lotTransfers: lotTransfers.map((l, idx) => ({
                          id: l.id,
                          tankId: values.transfers[idx].tankId
                        }))
                      },
                      awaitRefetchQueries: true,
                      refetchQueries
                    });

                    onSuccess();
                  } catch (err) {
                    console.error(err);
                    this.setError('An unknown error occured');
                    this.setSubmitting(false);
                  }
                }}
              >
                Transfer
              </SubmissionButton>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  }
}

export class TransferToBriteTankModal extends Component {
  render() {
    const {
      isOpen,
      onToggle,
      onSuccess,
      brewery,
      upcomingBrewCustomsReport,
      refetchQueries,
      lotTransfers
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Transfer to brite tanks</ModalHeader>
        <Query query={getBriteTanks} fetchPolicy="network-only" variables={{ breweryId: brewery.id }}>
          {props => {
            const { loading, error, data } = props;
            if (loading) {
              return (
                <div className="items-center flex justify-center">
                  <Loader className="pa4" />
                </div>
              );
            }

            if (error) {
              return <p className="pa4">Sorry, there was an error getting the brite tanks for transfer</p>;
            }

            return (
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                  transfers: lotTransfers
                }}
                onSubmit={async (values, { setErrors, setSubmitting }) => {}}
                render={props => {
                  return (
                    <TransferForm
                      {...props}
                      refetchQueries={refetchQueries}
                      brewery={brewery}
                      emptyTanks={data.tanks}
                      upcomingBrewCustomsReport={upcomingBrewCustomsReport}
                      lotTransfers={lotTransfers}
                      onCancelClick={onToggle}
                      onSuccess={onSuccess}
                    />
                  );
                }}
              />
            );
          }}
        </Query>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery,
    upcomingBrewCustomsReport: state.brewery.country.upcomingBrewCustomsReport
  };
}
export default connect(mapStateToProps)(TransferToBriteTankModal);



// WEBPACK FOOTER //
// ./src/containers/transferToBriteTankModal/transferToBriteTankModal.jsx